import React from 'react';
import Main from './Main';
import Footer from './Footer';

import './App.css';



const App = () => {
  return (
    
      <div className="App">
        <Main />
        <Footer />
      </div>

  );
};

export default App;
